import {action} from 'mobx'

import OfferFieldValueSource from './value_source/OfferFieldValueSource'
import OfferCustomParam from '../model/profile/OfferCustomParam'
import * as OfferType from '../constant/OfferType'

const TYPE_TO_TYPE_MAPPING = {
    [OfferType.SIMPLE]: {
        name_template: 'offer_simple_field_mapping_name_template',
        name: 'offer_simple_field_mapping_name',
        article: 'offer_simple_field_mapping_article',
        vendor: 'offer_simple_field_mapping_vendor',
        vendor_code: 'offer_simple_field_mapping_vendor_code',
        bid: 'offer_simple_field_mapping_bid',
        price: 'offer_simple_field_mapping_price',
        old_price: 'offer_simple_field_mapping_old_price',
        purchase_price: 'offer_simple_field_mapping_purchase_price',
        delivery: 'offer_simple_field_mapping_delivery',
        delivery_option_order_before: 'offer_simple_field_mapping_delivery_option_order_before',
        delivery_option_days: 'offer_simple_field_mapping_delivery_option_days',
        delivery_option_cost: 'offer_simple_field_mapping_delivery_option_cost',
        pickup: 'offer_simple_field_mapping_pickup',
        pickup_option_order_before: 'offer_simple_field_mapping_pickup_option_order_before',
        pickup_option_days: 'offer_simple_field_mapping_pickup_option_days',
        pickup_option_cost: 'offer_simple_field_mapping_pickup_option_cost',
        store: 'offer_simple_field_mapping_store',
        description: 'offer_simple_field_mapping_description',
        sales_notes: 'offer_simple_field_mapping_sales_notes',
        min_quantity: 'offer_simple_field_mapping_min_quantity',
        manufacturer_warranty: 'offer_simple_field_mapping_manufacturer_warranty',
        country_of_origin: 'offer_simple_field_mapping_country_of_origin',
        adult: 'offer_simple_field_mapping_adult',
        barcode: 'offer_simple_field_mapping_barcode',
        cpa: 'offer_simple_field_mapping_cpa',
        expiry: 'offer_simple_field_mapping_expiry',
        group_id: 'offer_simple_field_mapping_group_id',
        weight: 'offer_simple_field_mapping_weight',
        dimension_length: 'offer_simple_field_mapping_dimension_length',
        dimension_width: 'offer_simple_field_mapping_dimension_width',
        dimension_height: 'offer_simple_field_mapping_dimension_height',
        downloadable: 'offer_simple_field_mapping_downloadable',
        available: 'offer_simple_field_mapping_available',
        age: 'offer_simple_field_mapping_age',
        credit_template: 'offer_simple_field_mapping_credit_template',
        custom_params: 'offer_simple_field_mapping_custom_params',
        export_condition: 'offer_simple_export_condition',
        condition_type: 'offer_simple_field_mapping_condition_type',
        condition_reason: 'offer_simple_field_mapping_condition_reason',
        shop_sku: 'offer_simple_field_mapping_shop_sku',
        vat: 'offer_simple_field_mapping_vat'
    },
    [OfferType.COMBINED]: {
        name_template: 'offer_combined_field_mapping_name_template',
        name: 'offer_combined_field_mapping_name',
        model_template: 'offer_combined_field_mapping_model_template',
        article: 'offer_combined_field_mapping_article',
        vendor: 'offer_combined_field_mapping_vendor',
        vendor_code: 'offer_combined_field_mapping_vendor_code',
        type_prefix: 'offer_combined_field_mapping_type_prefix',
        bid: 'offer_combined_field_mapping_bid',
        price: 'offer_combined_field_mapping_price',
        old_price: 'offer_combined_field_mapping_old_price',
        purchase_price: 'offer_combined_field_mapping_purchase_price',
        delivery: 'offer_combined_field_mapping_delivery',
        delivery_option_order_before: 'offer_combined_field_mapping_delivery_option_order_before',
        delivery_option_days: 'offer_combined_field_mapping_delivery_option_days',
        delivery_option_cost: 'offer_combined_field_mapping_delivery_option_cost',
        pickup: 'offer_combined_field_mapping_pickup',
        pickup_option_order_before: 'offer_combined_field_mapping_pickup_option_order_before',
        pickup_option_days: 'offer_combined_field_mapping_pickup_option_days',
        pickup_option_cost: 'offer_combined_field_mapping_pickup_option_cost',
        store: 'offer_combined_field_mapping_store',
        description: 'offer_combined_field_mapping_description',
        sales_notes: 'offer_combined_field_mapping_sales_notes',
        min_quantity: 'offer_combined_field_mapping_min_quantity',
        manufacturer_warranty: 'offer_combined_field_mapping_manufacturer_warranty',
        country_of_origin: 'offer_combined_field_mapping_country_of_origin',
        adult: 'offer_combined_field_mapping_adult',
        barcode: 'offer_combined_field_mapping_barcode',
        cpa: 'offer_combined_field_mapping_cpa',
        expiry: 'offer_combined_field_mapping_expiry',
        group_id: 'offer_combined_field_mapping_group_id',
        weight: 'offer_combined_field_mapping_weight',
        dimension_length: 'offer_combined_field_mapping_dimension_length',
        dimension_width: 'offer_combined_field_mapping_dimension_width',
        dimension_height: 'offer_combined_field_mapping_dimension_height',
        downloadable: 'offer_combined_field_mapping_downloadable',
        available: 'offer_combined_field_mapping_available',
        age: 'offer_combined_field_mapping_age',
        credit_template: 'offer_combined_field_mapping_credit_template',
        custom_params: 'offer_combined_field_mapping_custom_params',
        export_condition: 'offer_combined_export_condition',
        condition_type: 'offer_combined_field_mapping_condition_type',
        condition_reason: 'offer_combined_field_mapping_condition_reason',
        shop_sku: 'offer_combined_field_mapping_shop_sku',
        vat: 'offer_combined_field_mapping_vat'
    },
    [OfferType.VENDOR_MODEL]: {
        downloadable: 'offer_vendor_model_field_mapping_downloadable',
        vendor: 'offer_vendor_model_field_mapping_vendor',
        vendor_code: 'offer_vendor_model_field_mapping_vendor_code',
        price: 'offer_vendor_model_field_mapping_price',
        old_price: 'offer_vendor_model_field_mapping_old_price',
        purchase_price: 'offer_vendor_model_field_mapping_purchase_price',
        model_template: 'offer_vendor_model_field_mapping_model_template',
        name: 'offer_vendor_model_field_mapping_name',
        article: 'offer_vendor_model_field_mapping_article',
        description: 'offer_vendor_model_field_mapping_description',
        available: 'offer_vendor_model_field_mapping_available',
        type_prefix: 'offer_vendor_model_field_mapping_type_prefix',
        sales_notes: 'offer_vendor_model_field_mapping_sales_notes',
        min_quantity: 'offer_vendor_model_field_mapping_min_quantity',
        step_quantity: 'offer_vendor_model_field_mapping_step_quantity',
        manufacturer_warranty: 'offer_vendor_model_field_mapping_manufacturer_warranty',
        seller_warranty: 'offer_vendor_model_field_mapping_seller_warranty',
        expiry: 'offer_vendor_model_field_mapping_expiry',
        group_id: 'offer_vendor_model_field_mapping_group_id',
        shop_sku: 'offer_vendor_model_field_mapping_shop_sku',
        vat: 'offer_vendor_model_field_mapping_vat',
        period_of_validity_days: 'offer_vendor_model_field_mapping_period_of_validity_days',
        service_life_days: 'offer_vendor_model_field_mapping_service_life_days',
        country_of_origin: 'offer_vendor_model_field_mapping_country_of_origin',
        adult: 'offer_vendor_model_field_mapping_adult',
        barcode: 'offer_vendor_model_field_mapping_barcode',
        export_condition: 'offer_vendor_model_export_condition',
        condition_type: 'offer_vendor_model_field_mapping_condition_type',
        condition_reason: 'offer_vendor_model_field_mapping_condition_reason',
        bid: 'offer_vendor_model_field_mapping_bid',
        weight: 'offer_vendor_model_field_mapping_weight',
        dimension_length: 'offer_vendor_model_field_mapping_dimension_length',
        dimension_width: 'offer_vendor_model_field_mapping_dimension_width',
        dimension_height: 'offer_vendor_model_field_mapping_dimension_height',
        age: 'offer_vendor_model_field_mapping_age',
        credit_template: 'offer_vendor_model_field_mapping_credit_template',
        store: 'offer_vendor_model_field_mapping_store',
        pickup: 'offer_vendor_model_field_mapping_pickup',
        pickup_option_order_before: 'offer_vendor_model_field_mapping_pickup_option_order_before',
        pickup_option_days: 'offer_vendor_model_field_mapping_pickup_option_days',
        pickup_option_cost: 'offer_vendor_model_field_mapping_pickup_option_cost',
        delivery: 'offer_vendor_model_field_mapping_delivery',
        delivery_option_order_before: 'offer_vendor_model_field_mapping_delivery_option_order_before',
        delivery_option_days: 'offer_vendor_model_field_mapping_delivery_option_days',
        delivery_option_cost: 'offer_vendor_model_field_mapping_delivery_option_cost',
        custom_params: 'offer_vendor_model_field_mapping_custom_params',
    },
}

export default class ProfileFieldMappingTransfer {
    /**
     * @param {ProfileSettings} profile
     * @param source_type
     * @param destination_type
     */
    @action cloneSettings(profile, source_type, destination_type) {
        const source_mapping = TYPE_TO_TYPE_MAPPING[source_type]
        const destination_mapping = TYPE_TO_TYPE_MAPPING[destination_type]

        if (!source_mapping || !destination_mapping) {
            return
        }

        Object.keys(source_mapping).forEach(field_type => {
            if (!destination_mapping[field_type]) {
                return
            }

            profile[destination_mapping[field_type]] = this.__cloneValue(profile[source_mapping[field_type]], field_type)
        })
    }

    __cloneValue(value, field_type) {
        if (field_type === 'export_condition') {
            return !!value
        } else if (field_type === 'custom_params') {
            return value.map(param => new OfferCustomParam(param))
        } else {
            return new OfferFieldValueSource(value)
        }
    }
}